import * as Styled from './PageSmallTitle.styles';

type PageSmallTitleProps = {
  title: string;
};
const PageSmallTitle = ({ title, ...props }: PageSmallTitleProps): JSX.Element => {
  return <Styled.Title {...props}>{title}</Styled.Title>;
};

export default PageSmallTitle;
